import '../App.css';
import React from 'react';
function AudioPlayer(props){
    return(
        <>
            <audio id={"audioid" + props.index} key={"audiokey" + props.index} controls>
                <source src={props.value} type="audio/mpeg" />
            </audio>
        </>
    );
}

export default AudioPlayer;